<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>POD Proof</strong>
               
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>           
              <b-col sm="4">
               <b-col sm="12" >

              
                         
           
                    <b-form-group label="DeliveryAgent" :label-cols="4" >
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select>
               </b-form-group>
                  </b-col>
              </b-col>
               <b-col sm="4">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
               <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

            </b-row>
           
            <b-row>
              <!--  <b-col md="4" class="my-1">
               <b-col sm="12">
                <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
              </b-col>
              </b-col>  -->
                <b-col sm="4">
                   <b-col sm="12">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="showimgthumbnails(1)"> Search</b-button>
                
                  <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10%"> clear</b-button>
                
                 
                </b-form-group>
              </b-col>
              </b-col>
              
            </b-row>
            <b-row>
            

              
             <div id="overlay" >
             <div class="loader"></div>
           </div>
            <b-col sm="12" class="text-right  " >
                <b>Total Records :<span style="color:red;">{{total_thum_Rows }}</span></b>   &nbsp;&nbsp;&nbsp;
               
              </b-col>
           <!-- :to="{ name: 'designsummry', params: { id: route_id } }" -->
           <!-- <b-col sm="12" class="text-right" >
                <router-link class="px-4 pull-right" to="" >
                    <b-button type="submit" variant="primary" class="px-4 pull-right" >View Thumbnails</b-button>
                </router-link>

            
              </b-col> -->
            
            </b-row> 
          </b-form>         
            
            <!-- Code for Thumbnail View of Image -->
             <div class="overflow-auto">
              
              <div class="col-md-12"  style="background-color: #c8ced3">
              <br>
              <div class="card" :current-page="currentPage" :perPage="perPage" style="background-color: #c8ced3; ">
             <div class="card-body" style="background-color: #c8ced3;">
                <div v-if="thumbnails.shipment_images!=null"  class="col-md-3" v-for="thumbnails in thumbnailview.slice((currentPage-1)*perPage,(currentPage-1)*perPage+perPage)" style="float: left; margin-bottom: 50px;">
                 
                   <div class="card-deck " >

                      <div class="card deck" >
                         <!----><!---->
                         <div class="card-body thumbnailbody">
                           
                            <p class="card-text">
                            
                            <div class="cardall">
                              <b-card-header header-tag="header" class="p-2 summaryheader">
                               
                                <strong v-b-tooltip.hover title="Shipping Id"> {{thumbnails.shippingid}}</strong>

                              </b-card-header>
                             
                                 <button v-b-modal.modal-lg type="button"  style="float: right;" class="btn btn-link"  @click="thumbnailimagemodel(thumbnails.shippingid)" >More Images</button>
                             
                                <div v-if="thumbnails.shipment_images!=null" style="text-align: center;" >
                                <!--   <img  v-bind:src=" thumbnails.shipment_images[0].imagepath" class="img_class" style=""></div> -->
                                <img  v-bind:src=" thumbnails.shipment_images[0].imagepath"  @click="thumbnailimagemodel(thumbnails.shippingid)" class="img_class" style=""></div>
                              
                         
                            </div>
                            </p>

                      </div>
                      <br><br><br><br>
                      <!-- {{designs.designer_name.substring(0,13)+".."}} 
                      thumbnails.shipment_images[0].imagepath-->
                      <div  class="card-footer summaryfooter">
                      
                          <label v-b-tooltip.hover :title="thumbnails.delivered_date" >
                          <strong>Delivered Date : </strong>
                          {{thumbnails.delivered_date.substring(0,10)+".."}} 
                        &nbsp;</label>
                       <label v-b-tooltip.hover :title="thumbnails.deliveryagentname" >
                          <strong> Delivery Agent : </strong>
                           {{thumbnails.deliveryagentname.substring(0,8)+".."}} 
                      </label>
                      <!-- </div> -->
                      <!-- </span> -->
                      <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                                          
                          
                     
                         </div>

                        
                      
                      </div>
                      
                   </div>
                   <br>
                

                </div>
                   
               
         
             </div>
          </div>
<!--  <b-col md="12" class="my-1" v-if="total_thum_Rows>'0'">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="total_thum_Rows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col> -->
            </div>
          <b-col md="12" class="my-1" v-if="total_thum_Rows>'20'">
             <b-pagination v-model="currentPage" :total-rows="total_thum_Rows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>
           </b-col>
          </div>
            <b-modal size="xl"  v-model="thumbimagemodel" hide-footer >
                    <template v-slot:modal-title>
                      <h3 >Shipment  Images</h3>
                    </template>
                          <template >
                          <!--  <div v-for="imgpath in thumbnailotherimg" class="d-block text-center" style="margin-bottom: 15px;" > -->
                            <!-- {{thumbnailotherimg[0]}} -->
                      
                     <!--  <img alt="This image is not available" style="width: 458px;height: 250px;" v-bind:src="imgpath.imagepath">  
                    </div> -->
                              <div class="card" :current-page="currentPage" :perPage="perPage" style="background-color: #ecf0f1; ">
             <div class="card-body" style="background-color: #ecf0f1;">
                <div v-for="imgpath in thumbnailotherimg"  class="col-md-3" style="float: left; margin-bottom: 50px;">
                 
                   <div class="card-deck " >

                      <div class="card " >
                         <!----><!---->
                         <div class="card-body thumbnailbody">
                           
                            <p class="card-text">
                            
                            <div class="cardall">
                                
                             <div  style="text-align: center;" > 
                              <img alt="This image is not available" class="img_class_model" v-bind:src="imgpath.imagepath">  
                            </div> 
                               <!--  <div v-if="thumbnails.shipment_images!=null" style="text-align: center;" > -->
                              
                                <!-- <img  v-bind:src=" thumbnails.shipment_images[0].imagepath" class="img_class" style=""></div> -->
                              
                         
                            </div>
                            </p>

                      </div>
                      <br><br><br><br>
                     

                        
                      
                      </div>
                      
                   </div>
                   <br>
                

                </div>
                   
               
         
             </div>
          </div>
                          </template>
                        <!--   <template v-else>
                          <p>Image is not available</p>
                          </template> -->
                   
                   


                  </b-modal>

        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      thumbimagemodel:false,
    
      thumbnailotherimg:[],
     
      thumbnailview:[],
      data: [], 
     currentPage:1,
     pageNum:1,
      hubid:'',
      data1:[],
      perPage:  20,
     
   
      awbno:'',
      deliveryagentid:'',
      agentmaster: [],
      
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
     
  
       
        total_thum_Rows:0,
      
        // searching:'',
    
      
    };
  },
  // computed: {
    // sortOptions() {
    //     // Create an options list from our fields
    //     return this.fields
    //       .filter(f => f.sortable)
    //       .map(f => {
    //         return { text: f.label, value: f.key }
    //       })
    //   }
  // },
     computed: {
        rows() {
          return this.items.length
        },
        
      },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.email=userInfo.sysemailid;
     
    this.hubid=userInfo.pickuplocationmasterid.toString();
   
   
    this.displaydeliveryagent();
    this.showimgthumbnails(this.pageNum);
  },
  methods: {
    
  
    validateForm(scope) {},
 
   

   
   


     
       // Function for  image model 
       thumbnailimagemodel:function(shipping_id){
        // alert(shippingid);
        // console.log("thumbnailview",this.thumbnailview.length);
        for(var i=0;i<=this.thumbnailview.length-1;i++){
          // console.log("This",this.thumbnailview[i].shippingid)
        if(shipping_id==this.thumbnailview[i].shippingid){
           // alert("hii");

          // for(var j=0;j<=this.thumbnailview[i].shipment_images.length-1;j++){
             // alert("jjjjjj");
            this.thumbnailotherimg=this.thumbnailview[i].shipment_images;
            // console.log("YYyyyyyyy", this.thumbnailotherimg);
        this.thumbimagemodel=!this.thumbimagemodel;
        // }
        }
        }
       },

  clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showimgthumbnails(pageNum);
    },
     showimgthumbnails: function(pagee) {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

     
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
         var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
        // var orderflow=(this.orderflow!=null && this.orderflow!='')? this.orderflow:"both";
         // var Pickup=(this.Pickup!=null && this.Pickup!='')? this.Pickup:"";
        
        // var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        // var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
        // var emiratescity=(this.emiratescity!=null)?this.emiratescity:"";

      
       // if(this.searching)
       //  {
          var thumbnailsObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
            // orderflow:orderflow,
            // Pickup:Pickup,
            // shipmentstatus:shipmentstatus,
            // shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid,
            // shippingid:'',
            // email:`${this.email}`,
            //page_no:pagee,
            // search_text:this.searching,
            //  hub_id:`${userInfo.pickuplocationmasterid}`,
            //   countrycode:`${userInfo.countrycode}`,
            // locality_city_name:emiratescity,
           };
         
        // }
        // else{

        //   var thumbnailsObj = {
        //     fromdate: `${fromdate}`,
        //     todate:`${formatdateto}`,
        //     // serviceid: `${this.hubid}`,
        //     // orderflow:orderflow,
        //     // Pickup:Pickup,
        //     // shipmentstatus:shipmentstatus,
        //     // shipmenttype:shipmenttype,
        //     deliveryagentid:this.deliveryagentid.key,
        //     // shippingid:'',
        //     // email:`${this.email}`,
        //     // page_no:pagee,
        //     // search_text:this.searching,
        //     //  hub_id:`${userInfo.pickuplocationmasterid}`,
        //     //  countrycode:`${userInfo.countrycode}`,
        //     //   locality_city_name:emiratescity,
        //   };
         
        // }
 

        if(formatdateto< fromdate){
           alert('To date need to be grater than From date');  
           // this.$fire({
           //        text:"To date need to be grater than From date",
           //        type: "warning",
           //        timer: 30000
           //      });         
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdeliveredshipmentlisthavingimages`, thumbnailsObj)
          .then(result => {
            // console.log("result",result);
             // this.isBusy = !this.isBusy;

          //  document.getElementById("loader").style.display = 'none'
            if (result.body.returnmsg  == 'Successful') {
              this.thumbnailview=result.body.returnvalue;
               // console.log("thumbnailview", this.thumbnailview);
               
                this.total_thum_Rows = result.body.returnvalue.length;  
                
            }else{
             
              this.total_thum_Rows = 0;    
              this.thumbnailview=result.body.returnvalue;           
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },


    
   



    

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
   this.searching="";
   this.deliveryagentid="";
   // this.Pickup="";
   // this.shipmentstatus="";
   // this.shipmenttype="";
   // this.selectDateFrom="";
   // this.selectDateTo="";
    // this.filter="";
    this.showimgthumbnails(this.pageNum);
   
   
      
    },
   








    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          // console.log("thumbnailviewdeliveryagent", this.agentmaster);
          // this.data1 = result.body

           // var data = [];
 
           //    result.body.forEach(function (srData) {
           //      data.push({
           //        key:srData.deliveryagentmasterid,
           //        label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
           //      });
           //    });
           //    this.data1 = data;
          // console.log("delivery11",this.data1);
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
.orderidClass{
   max-width: 110px !important;
}
.awbClass{
  max-width: 110px !important;
}
.statusClass{
 max-width: 110px !important; 
}
.desitnationClass{
  max-width: 110px !important; 
}
.countryClass{
 max-width: 60px !important;  
}
.pickupClass{
  max-width: 100px !important; 
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
.cardall{
  width: 100%;
  float: left; 
  margin-bottom: 30px;
  height: 140px ;
}
.img_class {
    width: 100%;
    height: 160px ;
    margin-top: 5px;
    text-align: center;
  
}
.thumbnailbody{
  padding:5px;
}
.img_class_model{
   width: 100%;
    height: 240px ;

    text-align: center;
}
.summaryfooter{
  padding:10px;
}
.deck{
  display: flex;
    flex: 1 0 0%;
    flex-direction: column;
    margin-right: 0px;
    margin-bottom: 0;
    margin-left: 15px;

}
</style>
